/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Build_Recommended_NoteInputs */

const en_us2_plan_build_recommended_note = /** @type {(inputs: Plan_Build_Recommended_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From your goal, equipment and injuries.`)
};

const pt_br2_plan_build_recommended_note = /** @type {(inputs: Plan_Build_Recommended_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pelo seu objetivo, equipamentos e lesões.`)
};

const es_419_plan_build_recommended_note = /** @type {(inputs: Plan_Build_Recommended_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Según tu objetivo, tu equipo y tus lesiones.`)
};

const pt_pt2_plan_build_recommended_note = /** @type {(inputs: Plan_Build_Recommended_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pelo teu objetivo, equipamento e lesões.`)
};

const fr_fr2_plan_build_recommended_note = /** @type {(inputs: Plan_Build_Recommended_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selon ton objectif, ton matériel et tes blessures.`)
};

const de_de2_plan_build_recommended_note = /** @type {(inputs: Plan_Build_Recommended_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nach deinem Ziel, deiner Ausrüstung und deinen Verletzungen.`)
};

const it_it2_plan_build_recommended_note = /** @type {(inputs: Plan_Build_Recommended_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In base a obiettivo, attrezzatura e infortuni.`)
};

/**
* | output |
* | --- |
* | "From your goal, equipment and injuries." |
*
* @param {Plan_Build_Recommended_NoteInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_build_recommended_note = /** @type {((inputs?: Plan_Build_Recommended_NoteInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Build_Recommended_NoteInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_build_recommended_note(inputs)
	if (locale === "es-419") return es_419_plan_build_recommended_note(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_build_recommended_note(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_build_recommended_note(inputs)
	if (locale === "de-DE") return de_de2_plan_build_recommended_note(inputs)
	if (locale === "it-IT") return it_it2_plan_build_recommended_note(inputs)
	return en_us2_plan_build_recommended_note(inputs)
});
export { plan_build_recommended_note as "plan-build.recommended_note" }